"use client"

import { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { CheckCircle, XCircle } from "lucide-react"

const comparisonPoints = ["point1", "point2", "point3", "point4", "point5"]

const GeneralRosetVsGpt = () => {
  const { t } = useTranslation("GeneralRosetVsGpt")
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return (
      <section className="py-20 bg-white dark:bg-slate-900">
        <div className="max-w-4xl mx-auto px-6">
          <div className="h-96 animate-pulse bg-gray-100 dark:bg-slate-700 rounded-xl"></div>
        </div>
      </section>
    )
  }

  return (
    <section className="py-20 bg-white dark:bg-slate-900">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-center text-gray-900 dark:text-white mb-4">
          {t("sectionTitle")}
        </h2>
        <p className="text-lg text-center text-gray-600 dark:text-slate-400 mb-12">
          {t("sectionSubtitle")}
        </p>
        <div className="bg-gray-50 dark:bg-slate-800 rounded-xl shadow-md overflow-hidden">
          <div className="grid grid-cols-3 font-semibold text-gray-800 dark:text-slate-200 border-b border-gray-200 dark:border-slate-700">
            <div className="p-4">{t("feature")}</div>
            <div className="p-4 text-center">RosetAI</div>
            <div className="p-4 text-center">ChatGPT</div>
          </div>
          {comparisonPoints.map((pointKey, idx) => (
            <div
              key={idx}
              className="grid grid-cols-3 items-center border-b border-gray-200 dark:border-slate-700 last:border-b-0"
            >
              <div className="p-4 text-gray-600 dark:text-slate-400">
                <p className="font-semibold text-gray-800 dark:text-slate-200">
                  {t(`${pointKey}.title`)}
                </p>
                <p className="text-sm">{t(`${pointKey}.desc`)}</p>
              </div>
              <div className="p-4 flex justify-center">
                <CheckCircle className="w-8 h-8 text-green-500" />
              </div>
              <div className="p-4 flex justify-center">
                <XCircle className="w-8 h-8 text-red-500" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default GeneralRosetVsGpt
